module.exports = __webpack_public_path__ + "img/Pawel_Korzeniowski.3f249d07.jpg";